
























import { Vue, Component, Inject } from "vue-property-decorator";
import { IShopProviderMethods } from "@/models/providers/basket/shop";

@Component({
  components: {
    "one-page-basket-items": () =>
      import(
        "@/components/app/global/baskets/basket/shared/onePageBasketItems.vue"
      ),
    "basket-promotions": () =>
      import("@/components/app/global/baskets/basket/basketPromos.vue"),
    "basket-totals": () =>
      import("@/components/app/global/baskets/basket/express/basketTotals.vue"),
    "basket-summary": () =>
      import("@/components/app/global/baskets/basket/express/basketSummary.vue")
  }
})
export default class OnePageCheckoutSummary extends Vue {
  @Inject({ from: "shopProviderMethods" })
  public readonly $shopMethods!: IShopProviderMethods;

  // Data

  public showSummary = false;

  // Computed

  public get expandSummary() {
    return this.$store.getters["ui/isDesktopPlus"] || this.showSummary;
  }

  // Methods

  public toggleSummary() {
    this.showSummary = !this.showSummary;
  }
}
